import { rankingItems } from '@/mocks/home';

const trendIconMap: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-500',
  down: 'ri-arrow-down-line text-foreground-400',
  stable: 'ri-subtract-line text-foreground-400',
};

const rankColorMap: Record<number, string> = {
  1: 'bg-accent-500 text-background-50',
  2: 'bg-primary-500 text-background-50',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              热度榜单
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">
              本周最热影片
            </h2>
            <p className="text-sm text-foreground-500 mt-3">
              基于全网影迷搜索与观看数据实时更新
            </p>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, index) => (
              <a
                key={item.id}
                href="#carousel"
                className={`flex items-center gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-background-100 ${
                  index < rankingItems.length - 1 ? 'border-b border-background-100' : ''
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                    rankColorMap[item.rank] || 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 truncate">{item.title}</h3>
                  <span className="text-xs text-foreground-400">{item.type}</span>
                </div>

                <div className="flex items-center gap-4 flex-shrink-0">
                  <div className="flex items-center gap-1">
                    <i className="ri-fire-line text-sm text-accent-500"></i>
                    <span className="text-sm font-bold text-accent-500">{item.heat}</span>
                  </div>
                  <i className={`text-sm ${trendIconMap[item.trend]}`}></i>
                </div>
              </a>
            ))}
          </div>

          <p className="text-center mt-4 text-xs text-foreground-400">
            数据来源：蓝莓影院近7日用户搜索与播放统计
          </p>
        </div>
      </div>
    </section>
  );
}